export default {
  lang: 'fr',
  dir: 'ltr',
  common: {
    ok: 'OK',
    cancel: 'Annuler',
    key_backspace: 'Retour en Arrière',
    key_del: 'Suppr.',
    key_down: 'Bas',
    key_up: 'Haut',
    more_opts: "Plus d'options",
    url: 'URL',
    width: 'Largeur',
    height: 'Hauteur'
  },
  misc: {
    powered_by: 'Propulsé par'
  },
  ui: {
    toggle_stroke_tools: "Montrer/cacher plus d'outils de contour",
    palette_info: 'Cliquer pour changer la couleur de remplissage, Maj+clic pour changer la couleur de contour',
    zoom_level: 'Changer le niveau de zoom',
    panel_action: 'Cliquer pour ouvrir le panel de côté',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: "Identifier l'élément",
    fill_color: 'Changer la couleur de remplissage',
    stroke_color: 'Changer la couleur du contour',
    stroke_style: 'Changer le style du contour',
    stroke_width: 'Changer la largeur du contour de 1, Maj+clic pour changer la largeur de 0,1',
    pos_x: "Changer l'abscisse (coordonnée X)",
    pos_y: "Changer l'ordonnée (coordonnée Y)",
    linecap_butt: 'Terminaison : Sur le nœud',
    linecap_round: 'Terminaison : Arrondie',
    linecap_square: 'Terminaison : Carrée',
    linejoin_bevel: 'Raccord : Biseauté',
    linejoin_miter: 'Raccord : Droit',
    linejoin_round: 'Raccord : Arrondi',
    angle: "Changer l'angle de rotation",
    blur: 'Changer la valeur du flou gaussien',
    opacity: "Changer l'opacité de l'élément sélectionné",
    circle_cx: 'Changer la position horizontale cx du cercle',
    circle_cy: 'Changer la position verticale cy du cercle',
    circle_r: 'Changer le rayon du cercle',
    ellipse_cx: "Changer la position horizontale cx de l'ellipse",
    ellipse_cy: "Changer la position verticale cy de l'ellipse",
    ellipse_rx: "Changer le rayon horizontal x de l'ellipse",
    ellipse_ry: "Changer le rayon vertical y de l'ellipse",
    line_x1: 'Changer la position horizontale x de début de la ligne',
    line_x2: 'Changer la position horizontale x de fin de la ligne',
    line_y1: 'Changer la position verticale y de début de la ligne',
    line_y2: 'Changer la position verticale y de fin de la ligne',
    rect_height: 'Changer la hauteur du rectangle',
    rect_width: 'Changer la largeur du rectangle',
    corner_radius: 'Changer le rayon des coins du rectangle',
    image_width: "Changer la largeur de l'image",
    image_height: "Changer la hauteur de l'image",
    image_url: "Modifier l'URL",
    node_x: 'Changer la positon horizontale x du nœud',
    node_y: 'Changer la position verticale y du nœud',
    seg_type: 'Changer le type du segment',
    straight_segments: 'Droit',
    curve_segments: 'Courbe',
    text_contents: 'Changer le contenu du texte',
    font_family_label: 'Font:',
    font_family: 'Changer la famille de police',
    font_size: 'Changer la taille de la police',
    bold: 'Texte en gras',
    italic: 'Texte en italique',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Menu principal',
    bkgnd_color_opac: "Changer la couleur d'arrière-plan/l'opacité",
    connector_no_arrow: 'Sans flèches',
    fitToContent: 'Ajuster au contenu',
    fit_to_all: "Ajuster à l'ensemble du contenu",
    fit_to_canvas: 'Ajuster au canevas',
    fit_to_layer_content: 'Ajuster au contenu du calque',
    fit_to_sel: 'Ajuster à la sélection',
    align_relative_to: 'Aligner par rapport à…',
    relativeTo: 'par rapport à :',
    page: 'page',
    largest_object: 'objet le plus gros',
    selected_objects: 'objets sélectionnés',
    smallest_object: 'objet le plus petit',
    new_doc: 'Nouvelle image',
    open_doc: 'Ouvrir une image SVG',
    export_img: 'Exporter',
    save_doc: "Enregistrer l'image",
    import_doc: 'Importer une image',
    align_to_page: "Aligner l'élément à la page",
    align_bottom: 'Aligner en bas',
    align_center: 'Centrer verticalement',
    align_left: 'Aligner à gauche',
    align_middle: 'Centrer horizontalement',
    align_right: 'Aligner à droite',
    align_top: 'Aligner en haut',
    mode_select: 'Outil de sélection',
    mode_fhpath: 'Crayon à main levée',
    mode_line: 'Tracer des lignes',
    mode_rect: 'Outil rectangle',
    mode_square: 'Outil carré',
    mode_fhrect: 'Rectangle à main levée',
    mode_ellipse: 'Ellipse',
    mode_circle: 'Cercle',
    mode_fhellipse: 'Ellipse à main levée',
    mode_path: 'Outil chemin',
    mode_text: 'Outil texte',
    mode_image: 'Outil image',
    mode_zoom: 'Zoom',
    no_embed: 'NOTE : Cette image ne peut pas être incorporée. Elle sera chargée à cette adresse',
    undo: 'Annuler',
    redo: 'Restaurer',
    tool_source: 'Modifier la source',
    wireframe_mode: 'Mode Fil de fer',
    clone: 'Cloner élément(s)',
    del: 'Supprimer élément(s)',
    group_elements: 'Grouper les éléments',
    make_link: 'Créer un hyperlien',
    set_link_url: "Définir l'URL du lien (laisser vide pour supprimer)",
    to_path: 'Convertir en chemin',
    reorient_path: 'Réorienter le chemin',
    ungroup: 'Dégrouper les éléments',
    docprops: 'Propriétés du document',
    editor_homepage: 'Page d\'accueil de SVG-Edit',
    move_bottom: 'Déplacer vers le bas',
    move_top: 'Déplacer vers le haut',
    node_clone: 'Cloner le nœud',
    node_delete: 'Supprimer le nœud',
    node_link: 'Rendre les points de contrôle solidaires',
    add_subpath: 'Ajouter un tracé secondaire',
    openclose_path: 'Ouvrir/fermer le sous-chemin',
    source_save: 'Appliquer les modifications',
    cut: 'Couper',
    copy: 'Copier',
    paste: 'Coller',
    paste_in_place: 'Coller sur place',
    delete: 'Supprimer',
    group: 'Grouper',
    move_front: 'Placer au premier plan',
    move_up: "Avancer d'un plan",
    move_down: "Reculer d'un plan",
    move_back: 'Placer au fond',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Outil Ellipse/Cercle',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Se souvenir de ce choix ?',
    remember_this_choice_title: 'Si vous choisissez de désactiver le stockage tout en mémorisant ce choix, l\'URL changera afin d\'éviter de vous le demander à nouveau.'
  },
  layers: {
    layer: 'Calque',
    layers: 'Calques',
    del: 'Supprimer le calque',
    move_down: 'Descendre le calque',
    new: 'Nouveau calque',
    rename: 'Renommer le calque',
    move_up: 'Monter le calque',
    dupe: 'Dupliquer le calque',
    merge_down: 'Fusionner vers le bas',
    merge_all: 'Tout fusionner',
    move_elems_to: 'Déplacer les éléments vers :',
    move_selected: 'Déplacer les éléments sélectionnés vers un autre calque'
  },
  config: {
    image_props: "Propriétés de l'image",
    doc_title: 'Titre',
    doc_dims: 'Dimensions du canevas',
    included_images: 'Images insérées',
    image_opt_embed: 'Incorporer les données des images (fichiers locaux)',
    image_opt_ref: "Utiliser l'adresse des fichiers",
    editor_prefs: "Préférences de l'éditeur",
    language: 'Langue',
    background: "Toile de fond de l'éditeur",
    editor_img_url: 'Image URL',
    editor_bg_note: "Note : La toile de fond ne sera pas sauvegardée avec l'image.",
    select_predefined: 'Sélectionner prédéfinis :',
    units_and_rulers: 'Unités et règles',
    show_rulers: 'Afficher les règles',
    base_unit: 'Unité de mesure :',
    grid: 'Grille',
    snapping_onoff: 'Ancrer oui/non',
    snapping_stepsize: "Pas d'ancrage :",
    grid_color: 'Couleur de la grille',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'Nouvelle couleur - Appuyez sur &ldquo;OK&rdquo; pour valider',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Dégradé linéaire',
    jgraduate_radial_gradient: 'Dégradé radial',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Cliquez pour définir l\'angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Valeur fournie invalide',
    noContentToFitTo: "Il n'y a pas de contenu auquel ajuster",
    dupeLayerName: 'Un autre calque porte déjà ce nom !',
    enterUniqueLayerName: 'Veuillez entrer un nom (unique) pour le calque',
    enterNewLayerName: 'Veuillez entrer le nouveau nom du calque',
    layerHasThatName: 'Le calque porte déjà ce nom',
    QmoveElemsToLayer: 'Déplacer les éléments sélectionnés vers le calque « %s » ?',
    QwantToClear: "Voulez-vous effacer le dessin ?\nL'historique de vos actions sera également effacé !",
    QwantToOpen: "Voulez-vous ouvrir un nouveau document ?\nVous perdrez l'historique de vos modifications !",
    QerrorsRevertToSource: 'Il y a des erreurs de syntaxe dans votre code source SVG.\nRestaurer le code source SVG antérieur aux modifications ?',
    QignoreSourceChanges: 'Ignorer les modifications faites à la source SVG ?',
    featNotSupported: 'Fonction non supportée',
    enterNewImgURL: "Entrer la nouvelle URL de l'image",
    defsFailOnSave: "NOTE : En raison d'un bogue dans votre navigateur, il se peut que cette image ne soit pas correctement affichée (dégradés ou éléments manquants). Le souci sera néanmoins réglé à la sauvegarde.",
    loadingImage: "Chargement de l'image, veuillez patienter…",
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Notez également les problèmes suivants : ',
    unsavedChanges: 'Il y a des changements non sauvegardés.',
    enterNewLinkURL: "Entrez la nouvelle URL de l'hyperlien",
    errorLoadingSVG: 'Erreur : Impossible de charger les données SVG',
    URLLoadFail: "Impossible de charger l'URL",
    retrieving: 'Récupération de « %s »…',
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
};
